/* ═══════════════════════════════════════
   Page-specific translations
   ═══════════════════════════════════════ */
const pageT = {
  ko: {
    // Home
    homeTitle: "사주팔자AI - AI 사주 타로 궁합 만세력 | 2026 운세",
    homeDesc: "2026년 최신 AI가 분석하는 사주, 타로, 궁합, 만세력 서비스",
    heroTitle: "사주팔자AI",
    heroSubtitle: "AI가 분석하는 사주 · 타로 · 운세",
    viewFortune: "운세 보기",
    // Quick dial
    manseryeok: "만세력",
    aiSaju: "AI사주",
    gunghap: "궁합",
    tarot: "타로",
    asciiTarot: "ASCII타로",
    // Free services
    // Fortune services
    fortuneServices: "운세 서비스",
    aiSajuAnalysis: "AI 사주분석",
    aiSajuDesc: "전통 명리학과 AI의 만남",
    manseryeokTitle: "만세력",
    manseryeokDesc: "전문가용 사주팔자 분석",
    manseryeokAITitle: "만세력 AI 해석",
    manseryeokAIDesc: "AI가 만세력을 해석",
    aiTarotReading: "AI 타로리딩",
    aiTarotDesc: "AI가 해석하는 타로",
    aiGunghapTitle: "AI 궁합분석",
    aiGunghapDesc: "두 사람의 사주 궁합",
    // Featured
    featuredServices: "추천 서비스",
    psychtestTitle: "심리테스트",
    psychtestDesc: "MBTI · 성격 유형 분석",
    // Community
    communityTitle: "커뮤니티",
    galleryTitle: "촉점 갤러리",
    galleryDesc: "자유롭게 이야기하는 커뮤니티",
    // Tools
    toolsTitle: "도구",
    boardTitle: "사주팔자 게시판",
    boardDesc: "운세 · 사주 토론",
    encyclopediaTitle: "학습 자료",
    encyclopediaDesc: "사주 용어 · 개념 해설",
    devPortalTitle: "개발자 포털",
    devPortalDesc: "MobidicSaju API · CLI 도구",
    // Features
    whyUs: "왜 사주팔자AI인가요?",
    featAI: "AI 분석",
    featAIDesc: "최신 AI로 정확하게",
    featFast: "빠른 결과",
    featFastDesc: "입력 후 즉시 확인",
    featSafe: "개인정보 보호",
    featSafeDesc: "안전한 데이터 관리",
    // CTA
    ctaTitle: "오늘의 운세를 확인해보세요",
    ctaSub: "사랑 · 재물 · 직업 · 건강 운을 한눈에",
    ctaSaju: "AI 사주 분석",
    ctaTarot: "타로 리딩",
    // SajuFarm
    sajuFarmTitle: "사주 라이프 처방전",
    sajuFarmDesc: "오행 식물 · 약선 · 절기 · 풍수 · 실록 검색",
    annalsTitle: "조선왕조실록",
    annalsDesc: "531,740건 실록 + 지리지 RAG 검색",

    // Developer Portal
    devHeroTitle: "MobidicSaju API Platform",
    devHeroSub: "사주 명리학 AI 해석 API. 사주 분석과 AI 해석을 당신의 서비스에 통합하세요.",
    devApproved: "개발자 승인 완료",
    tabOverview: "시작하기",
    tabDocs: "API 문서",
    tabKeys: "API 키",
    tabUsage: "사용량",
    // Overview
    securityTitle: "API 키 보안 주의",
    securityNoSource: "API 키를 절대 소스코드, Git 저장소, 프론트엔드에 포함하지 마세요.",
    securityRevoke: "API 키가 노출되면 즉시 비활성화하고 새 키를 발급하세요.",
    securityEnvVar: "환경변수 (MOBIDIC_API_KEY) 또는 비밀 관리 서비스를 사용하세요.",
    securityBackend: "API 키는 서버 측(backend)에서만 사용하세요. 브라우저에서 호출하면 키가 노출됩니다.",
    prepaidTitle: "선불 포인트 결제",
    prepaidDesc: "MobidicSaju API는 선불 포인트 차감 방식입니다.",
    prepaidFlow: "1. 포인트 충전 → 2. API 호출 → 3. 자동 차감",
    prepaidWarn: "포인트 잔액 부족 시 API 요청이 402 (Payment Required)로 거부됩니다.",
    chargeLink: "포인트 충전 페이지",
    modelsTitle: "모델",
    proLabel: "Pro",
    liteLabel: "Lite",
    liteSave: "34% 저렴",
    perRequest: "/ 요청",
    engineLabel: "티어",
    priceCompare: "가격 비교",
    thModel: "모델",
    thEngine: "티어",
    thFormat: "결과 형식",
    thPrice: "가격",
    thFeatures: "특징",
    manseryeokPlusInterp: "사주 요약 + 해석",
    interpOnly: "해석만",
    apiFlow: "API 흐름",
    flowCharge: "포인트 충전",
    flowCall: "API 호출",
    flowBalance: "잔액 확인",
    flowCalc: "만세력 계산",
    flowAI: "AI 해석",
    flowResponse: "JSON 응답 + 차감",
    flowRNote: "R / R-lite: AI 해석 결과만 반환",
    flowMNote: "M / M-lite: 사주 요약 + 오행 밸런스 + AI 해석 결과 반환",
    flowProNote: "Pro: MobidicAI Pro (높은 품질) | Lite: MobidicAI Lite (빠르고 저렴)",
    flowSessionNote: "각 요청은 세션 토큰을 반환하며, 이를 사용해 추가 질문이 가능합니다.",
    flowBalanceNote: "포인트 잔액이 부족하면 요청이 거부됩니다 (HTTP 402).",
    devApplyTitle: "개발자 계정 신청",
    devApplyRejected: "이전 신청이 거부되었습니다. 내용을 수정하여 다시 신청할 수 있습니다.",
    companyName: "회사/서비스명",
    website: "웹사이트",
    purpose: "사용 목적",
    purposePlaceholder: "API를 어떤 서비스에 활용하실 계획인지 알려주세요.",
    applying: "신청 중...",
    applyBtn: "개발자 계정 신청",
    pendingTitle: "신청 현황",
    pendingDesc: "개발자 신청이 접수되었습니다. 관리자 승인 후 API 키 발급이 가능합니다.",
    reviewing: "심사 중",
    // Keys tab
    keyCreated: "API 키가 생성되었습니다",
    keyOnce: "이 키는 한 번만 표시됩니다. 안전한 곳에 저장해주세요.",
    newKeyTitle: "새 API 키 생성",
    keyNamePlaceholder: "키 이름 (예: Production, Test)",
    createBtn: "생성",
    maxKeys: "최대 5개의 활성 키를 보유할 수 있습니다.",
    keyListTitle: "API 키 목록",
    noKeys: "생성된 API 키가 없습니다.",
    active: "활성",
    inactive: "비활성",
    deactivate: "비활성화",
    created: "생성",
    lastUsed: "마지막 사용",
    // Docs tab
    authTitle: "인증 & API 키 보안",
    authDesc: "모든 API 요청에는 X-API-Key 헤더가 필요합니다.",
    cliTitle: "CLI 도구 (터미널에서 사용)",
    cliDesc: "Ollama 스타일의 CLI 도구로 터미널에서 바로 사주 분석을 수행할 수 있습니다.",
    cliReq: "Python 3.6+ 이 설치되어 있으면 별도 라이브러리 없이 바로 사용 가능합니다.",
    cliPlatform: "✅ macOS, Linux, Windows 지원 | CLI는 영어 전용입니다.",
    cliModelTip: "모델 선택 안내",
    cliModelDesc: "4가지 모델 중 원하는 모델을 선택할 수 있습니다:",
    cliModelR: "AI 해석만 (₩500/요청)",
    cliModelM: "AI 해석 + 만세력 데이터 (₩700/요청)",
    cliModelRLite: "AI 해석만, 저렴·빠름 (₩330/요청)",
    cliModelMLite: "AI 해석 + 만세력, 저렴·빠름 (₩462/요청)",
    cliSslTitle: "SSL 오류 해결 (macOS / Windows)",
    cliSslDesc: "CERTIFICATE_VERIFY_FAILED 오류가 나면:",
    cliSslStep1: "실행 (가장 간단, 모든 OS)",
    installTitle: "설치",
    basicCommands: "기본 명령어",
    interactiveMode: "대화형 모드 (ollama run 스타일)",
    quickstartTitle: "Quickstart — HTTP API",
    step1Analyze: "1. 사주 분석 (선불 포인트 자동 차감)",
    step2Followup: "2. 추가 질문 (세션 유지)",
    apiRefTitle: "API 레퍼런스",
    paramName: "파라미터",
    paramType: "타입",
    paramRequired: "필수",
    paramDesc: "설명",
    responseTitle: "응답 형식 표준 (JSON + Markdown)",
    responseDesc: "모든 응답은 JSON 형식으로 반환됩니다. AI 해석 텍스트는 Markdown 문법으로 작성됩니다.",
    responseRTitle: "R / R-lite 응답 (해석만)",
    responseMTitle: "M / M-lite 응답 (사주 요약 + 해석)",
    responseLiteTitle: "Lite 모델 응답 예시",
    formatSpec: "형식 규격",
    errorCodesTitle: "에러 코드",
    errorExample: "에러 응답 예시",
    thHTTP: "HTTP",
    thCode: "코드",
    thDescription: "설명",
    // Usage tab
    totalRequests: "총 요청",
    successRequests: "성공 요청",
    totalCost: "총 비용",
    avgResponse: "평균 응답",
    byModel: "모델별 사용량",
    noUsage: "사용 내역이 없습니다.",
    dailyTrend: "일별 추이",
    currentPricing: "현재 단가",
    // Login required
    loginRequired: "개발자 포털을 이용하려면 로그인이 필요합니다.",
    // B2B Guide
    b2bGuideTitle: "B2B 통합 가이드",
    b2bGuideDesc: "MobidicSaju API를 활용하여 사주 분석 서비스를 구축하는 종합 가이드입니다.",
    b2bArch: "아키텍처 권장 사항",
    b2bArchDesc: "API 키는 반드시 백엔드 서버에서만 호출하세요. 프론트엔드(JavaScript)에서 직접 호출하면 키가 노출됩니다.",
    b2bErrorTitle: "에러 핸들링 베스트 프랙티스",
    b2bRateTitle: "요청 제한 & 최적화",
    b2bWebhookTitle: "결과 캐싱 전략",
    b2bBestPractices: "프로덕션 베스트 프랙티스",
    b2bTip1: "API 키는 반드시 서버 측에서만 사용 — 프론트엔드에 절대 노출 금지",
    b2bTip2: "사용자당 요청 속도 제한(rate limiting) 구현",
    b2bTip3: "결과 캐싱으로 동일 요청 중복 호출 방지",
    b2bTip4: "timeout 설정 (권장 30초) — AI 분석에 시간이 걸릴 수 있음",
    b2bTip5: "잔액 부족 (402) 에러 대비 — 자동 알림 시스템 구축",
    b2bTip6: "session_token으로 추가 질문 기능 활용 — 사용자 경험 향상",
  },
  en: {
    homeTitle: "SajuPaljaAI - Free AI Fortune Tarot Compatibility Analysis | 2026",
    homeDesc: "AI-powered Saju, Tarot, and Compatibility analysis based on traditional Korean fortune-telling",
    heroTitle: "SajuPalja AI",
    heroSubtitle: "AI-Powered Saju · Tarot · Fortune",
    viewFortune: "Get Fortune",
    manseryeok: "Manseryeok",
    aiSaju: "AI Saju",
    gunghap: "Compatibility",
    tarot: "Tarot",
    asciiTarot: "ASCII Tarot",
    fortuneServices: "Fortune Services",
    aiSajuAnalysis: "AI Saju Analysis",
    aiSajuDesc: "Where tradition meets AI",
    manseryeokTitle: "Manseryeok",
    manseryeokDesc: "Professional four-pillar chart",
    manseryeokAITitle: "Manseryeok AI",
    manseryeokAIDesc: "AI interprets your chart",
    aiTarotReading: "AI Tarot Reading",
    aiTarotDesc: "AI-interpreted tarot cards",
    aiGunghapTitle: "AI Compatibility",
    aiGunghapDesc: "Compatibility between two people",
    featuredServices: "Featured Services",
    psychtestTitle: "Psych Test",
    psychtestDesc: "MBTI & personality type analysis",
    communityTitle: "Community",
    galleryTitle: "Gallery",
    galleryDesc: "Free-form community discussions",
    toolsTitle: "Tools",
    boardTitle: "Saju Forum",
    boardDesc: "Fortune & Saju discussions",
    encyclopediaTitle: "Learning Resources",
    encyclopediaDesc: "Saju terminology & concepts",
    devPortalTitle: "Developer Portal",
    devPortalDesc: "MobidicSaju API & CLI tools",
    whyUs: "Why SajuPaljaAI?",
    featAI: "AI Analysis",
    featAIDesc: "Accurate with latest AI",
    featFast: "Fast Results",
    featFastDesc: "Instant after input",
    featSafe: "Privacy Protection",
    featSafeDesc: "Secure data management",
    ctaTitle: "Check today's fortune",
    ctaSub: "Love · Wealth · Career · Health at a glance",
    ctaSaju: "AI Saju Analysis",
    ctaTarot: "Tarot Reading",
    // SajuFarm
    sajuFarmTitle: "Saju Life Prescription",
    sajuFarmDesc: "Plants · Herbal food · Season · Feng shui · Annals",
    annalsTitle: "Joseon Annals",
    annalsDesc: "531K records + Geography RAG search",
    devHeroTitle: "MobidicSaju API Platform",
    devHeroSub: "Saju (Four Pillars) AI Interpretation API. Integrate Saju analysis and AI insights into your service.",
    devApproved: "Developer Approved",
    tabOverview: "Get Started",
    tabDocs: "API Docs",
    tabKeys: "API Keys",
    tabUsage: "Usage",
    securityTitle: "API Key Security Notice",
    securityNoSource: "NEVER include API keys in source code, Git repos, or frontend code.",
    securityRevoke: "If a key is exposed, deactivate it immediately and issue a new one.",
    securityEnvVar: "Use environment variables (MOBIDIC_API_KEY) or a secrets manager.",
    securityBackend: "Only call the API from your backend server. Browser calls expose the key.",
    prepaidTitle: "Prepaid Point Billing",
    prepaidDesc: "MobidicSaju API uses a prepaid point deduction model.",
    prepaidFlow: "1. Charge Points → 2. API Call → 3. Auto Deduction",
    prepaidWarn: "Requests are rejected with 402 (Payment Required) when balance is insufficient.",
    chargeLink: "Charge Points",
    modelsTitle: "Models",
    proLabel: "Pro",
    liteLabel: "Lite",
    liteSave: "34% cheaper",
    perRequest: "/ request",
    engineLabel: "Tier",
    priceCompare: "Price Comparison",
    thModel: "Model",
    thEngine: "Tier",
    thFormat: "Output Format",
    thPrice: "Price",
    thFeatures: "Features",
    manseryeokPlusInterp: "Saju Summary + Interpretation",
    interpOnly: "Interpretation only",
    apiFlow: "API Flow",
    flowCharge: "Charge Points",
    flowCall: "API Call",
    flowBalance: "Balance Check",
    flowCalc: "Manseryeok Calc",
    flowAI: "AI Interpretation",
    flowResponse: "JSON Response + Deduction",
    flowRNote: "R / R-lite: Returns AI interpretation only",
    flowMNote: "M / M-lite: Returns Saju summary + Wuxing balance + AI interpretation",
    flowProNote: "Pro: MobidicAI Pro (high quality) | Lite: MobidicAI Lite (fast & affordable)",
    flowSessionNote: "Each request returns a session token for follow-up questions.",
    flowBalanceNote: "Requests are rejected when balance is insufficient (HTTP 402).",
    devApplyTitle: "Apply for Developer Account",
    devApplyRejected: "Your previous application was rejected. You may reapply with updated info.",
    companyName: "Company / Service Name",
    website: "Website",
    purpose: "Purpose",
    purposePlaceholder: "Describe how you plan to use the API.",
    applying: "Applying...",
    applyBtn: "Apply for Developer Account",
    pendingTitle: "Application Status",
    pendingDesc: "Your application is under review. API key issuance is available after admin approval.",
    reviewing: "Under Review",
    keyCreated: "API Key Created",
    keyOnce: "This key is shown only once. Store it securely.",
    newKeyTitle: "Create New API Key",
    keyNamePlaceholder: "Key name (e.g., Production, Test)",
    createBtn: "Create",
    maxKeys: "You can have up to 5 active keys.",
    keyListTitle: "API Key List",
    noKeys: "No API keys created.",
    active: "Active",
    inactive: "Inactive",
    deactivate: "Deactivate",
    created: "Created",
    lastUsed: "Last used",
    authTitle: "Authentication & API Key Security",
    authDesc: "All API requests require the X-API-Key header.",
    cliTitle: "CLI Tool (Terminal Usage)",
    cliDesc: "An Ollama-style CLI tool for Saju analysis directly from your terminal.",
    cliReq: "Works out of the box with Python 3.6+ — no extra libraries needed.",
    cliPlatform: "✅ macOS, Linux, Windows supported | CLI is English-only.",
    cliModelTip: "Model Selection Guide",
    cliModelDesc: "Choose from 4 available models:",
    cliModelR: "AI interpretation only (₩500/request)",
    cliModelM: "AI interpretation + Manseryeok data (₩700/request)",
    cliModelRLite: "AI interpretation only, affordable & fast (₩330/request)",
    cliModelMLite: "AI interpretation + Manseryeok, affordable & fast (₩462/request)",
    cliSslTitle: "SSL Error Fix (macOS / Windows)",
    cliSslDesc: "If you see CERTIFICATE_VERIFY_FAILED:",
    cliSslStep1: "Run this (simplest, all OS)",
    installTitle: "Installation",
    basicCommands: "Basic Commands",
    interactiveMode: "Interactive Mode (ollama run style)",
    quickstartTitle: "Quickstart — HTTP API",
    step1Analyze: "1. Saju Analysis (auto point deduction)",
    step2Followup: "2. Follow-up Question (session-based)",
    apiRefTitle: "API Reference",
    paramName: "Parameter",
    paramType: "Type",
    paramRequired: "Required",
    paramDesc: "Description",
    responseTitle: "Response Format (JSON + Markdown)",
    responseDesc: "All responses are in JSON. AI interpretation text uses Markdown formatting.",
    responseRTitle: "R / R-lite Response (interpretation only)",
    responseMTitle: "M / M-lite Response (Saju Summary + Interpretation)",
    responseLiteTitle: "Lite Model Response Example",
    formatSpec: "Format Specification",
    errorCodesTitle: "Error Codes",
    errorExample: "Error Response Example",
    thHTTP: "HTTP",
    thCode: "Code",
    thDescription: "Description",
    totalRequests: "Total Requests",
    successRequests: "Successful",
    totalCost: "Total Cost",
    avgResponse: "Avg Response",
    byModel: "Usage by Model",
    noUsage: "No usage data.",
    dailyTrend: "Daily Trend",
    currentPricing: "Current Pricing",
    loginRequired: "Please log in to access the Developer Portal.",
    b2bGuideTitle: "B2B Integration Guide",
    b2bGuideDesc: "A comprehensive guide to building Saju analysis services using the MobidicSaju API.",
    b2bArch: "Architecture Recommendations",
    b2bArchDesc: "Always call the API from your backend server. Never expose the API key in frontend JavaScript.",
    b2bErrorTitle: "Error Handling Best Practices",
    b2bRateTitle: "Rate Limits & Optimization",
    b2bWebhookTitle: "Result Caching Strategy",
    b2bBestPractices: "Production Best Practices",
    b2bTip1: "Only use API keys server-side — never expose in frontend code",
    b2bTip2: "Implement per-user rate limiting",
    b2bTip3: "Cache results to prevent duplicate API calls",
    b2bTip4: "Set timeout (recommended 30s) — AI analysis may take time",
    b2bTip5: "Handle insufficient balance (402) — set up auto-alerts",
    b2bTip6: "Use session_token for follow-up questions — enhance UX",
  },
  ja: {
    homeTitle: "四柱八字AI - 無料AI占い・タロット・相性・万世暦 | 2026",
    homeDesc: "最新AIによる四柱推命、タロット、相性分析サービス",
    heroTitle: "四柱八字AI",
    heroSubtitle: "AIが分析する四柱 · タロット · 占い",
    viewFortune: "占いを見る",
    manseryeok: "万世暦",
    aiSaju: "AI四柱",
    gunghap: "相性",
    tarot: "タロット",
    asciiTarot: "ASCIIタロット",
    fortuneServices: "占いサービス",
    aiSajuAnalysis: "AI 四柱分析",
    aiSajuDesc: "伝統命理学とAIの融合",
    manseryeokTitle: "万世暦",
    manseryeokDesc: "専門家向け四柱八字分析",
    manseryeokAITitle: "万世暦AI解釈",
    manseryeokAIDesc: "AIが万世暦を解釈",
    aiTarotReading: "AI タロットリーディング",
    aiTarotDesc: "AIが解釈するタロット",
    aiGunghapTitle: "AI 相性分析",
    aiGunghapDesc: "二人の四柱相性",
    featuredServices: "おすすめサービス",
    psychtestTitle: "心理テスト",
    psychtestDesc: "MBTI・性格タイプ分析",
    communityTitle: "コミュニティ",
    galleryTitle: "ギャラリー",
    galleryDesc: "自由に語り合うコミュニティ",
    toolsTitle: "ツール",
    boardTitle: "四柱掲示板",
    boardDesc: "占い・四柱の議論",
    encyclopediaTitle: "学習資料",
    encyclopediaDesc: "四柱用語・概念解説",
    devPortalTitle: "開発者ポータル",
    devPortalDesc: "MobidicSaju API & CLIツール",
    whyUs: "なぜ四柱八字AIなのか？",
    featAI: "AI分析",
    featAIDesc: "最新AIで正確に",
    featFast: "高速結果",
    featFastDesc: "入力後すぐに確認",
    featSafe: "プライバシー保護",
    featSafeDesc: "安全なデータ管理",
    ctaTitle: "今日の運勢を確認しましょう",
    ctaSub: "恋愛・財運・仕事・健康を一目で",
    ctaSaju: "AI 四柱分析",
    ctaTarot: "タロットリーディング",
    // SajuFarm
    sajuFarmTitle: "四柱ライフ処方箋",
    sajuFarmDesc: "植物 · 薬膳 · 節気 · 風水 · 実録検索",
    annalsTitle: "朝鮮王朝実録",
    annalsDesc: "531,740件実録 + 地理志 RAG検索",
    devHeroTitle: "MobidicSaju APIプラットフォーム",
    devHeroSub: "四柱推命AI解釈API。四柱分析とAI解釈をあなたのサービスに統合。",
    devApproved: "開発者承認済み",
    tabOverview: "スタート",
    tabDocs: "APIドキュメント",
    tabKeys: "APIキー",
    tabUsage: "使用量",
    securityTitle: "APIキーセキュリティ注意",
    securityNoSource: "APIキーをソースコード、Gitリポジトリ、フロントエンドに絶対に含めないでください。",
    securityRevoke: "キーが漏洩した場合、直ちに無効化し、新しいキーを発行してください。",
    securityEnvVar: "環境変数（MOBIDIC_API_KEY）またはシークレット管理サービスを使用してください。",
    securityBackend: "APIキーはサーバー側（バックエンド）でのみ使用してください。",
    prepaidTitle: "前払いポイント決済",
    prepaidDesc: "MobidicSaju APIは前払いポイント差引方式です。",
    prepaidFlow: "1. ポイントチャージ → 2. API呼び出し → 3. 自動差引",
    prepaidWarn: "ポイント残高不足時、APIリクエストは402で拒否されます。",
    chargeLink: "ポイントチャージページ",
    modelsTitle: "モデル",
    proLabel: "Pro",
    liteLabel: "Lite",
    liteSave: "34%お得",
    perRequest: "/ リクエスト",
    engineLabel: "ティア",
    priceCompare: "価格比較",
    thModel: "モデル",
    thEngine: "ティア",
    thFormat: "出力形式",
    thPrice: "価格",
    thFeatures: "機能",
    manseryeokPlusInterp: "四柱要約 + 解釈",
    interpOnly: "解釈のみ",
    apiFlow: "APIフロー",
    flowCharge: "ポイントチャージ",
    flowCall: "API呼び出し",
    flowBalance: "残高確認",
    flowCalc: "万世暦計算",
    flowAI: "AI解釈",
    flowResponse: "JSONレスポンス + 差引",
    flowRNote: "R / R-lite: AI解釈結果のみ返却",
    flowMNote: "M / M-lite: 四柱要約 + 五行バランス + AI解釈を返却",
    flowProNote: "Pro: MobidicAI Pro（高品質）| Lite: MobidicAI Lite（高速・低価格）",
    flowSessionNote: "各リクエストはセッショントークンを返し、追加質問に使用できます。",
    flowBalanceNote: "ポイント残高不足時、リクエストは拒否されます（HTTP 402）。",
    devApplyTitle: "開発者アカウント申請",
    devApplyRejected: "前回の申請が却下されました。内容を修正して再申請できます。",
    companyName: "会社/サービス名",
    website: "ウェブサイト",
    purpose: "使用目的",
    purposePlaceholder: "APIをどのサービスに活用する予定か教えてください。",
    applying: "申請中...",
    applyBtn: "開発者アカウント申請",
    pendingTitle: "申請状況",
    pendingDesc: "開発者申請が受け付けられました。管理者承認後、APIキー発行が可能です。",
    reviewing: "審査中",
    keyCreated: "APIキーが作成されました",
    keyOnce: "このキーは一度だけ表示されます。安全な場所に保存してください。",
    newKeyTitle: "新しいAPIキーの作成",
    keyNamePlaceholder: "キー名（例: Production, Test）",
    createBtn: "作成",
    maxKeys: "最大5つのアクティブキーを保持できます。",
    keyListTitle: "APIキー一覧",
    noKeys: "作成されたAPIキーはありません。",
    active: "アクティブ",
    inactive: "無効",
    deactivate: "無効化",
    created: "作成日",
    lastUsed: "最終使用",
    authTitle: "認証 & APIキーセキュリティ",
    authDesc: "すべてのAPIリクエストにはX-API-Keyヘッダーが必要です。",
    cliTitle: "CLIツール（ターミナル使用）",
    cliDesc: "Ollamaスタイルのターミナルから四柱分析を行えるCLIツール。",
    cliReq: "Python 3.6+ があればそのまま使えます。追加ライブラリ不要。",
    cliPlatform: "✅ macOS, Linux, Windows 対応 | CLIは英語のみ。",
    cliModelTip: "モデル選択ガイド",
    cliModelDesc: "4つのモデルから選択可能：",
    cliModelR: "AI解釈のみ（₩500/リクエスト）",
    cliModelM: "AI解釈 + 万歳暦データ（₩700/リクエスト）",
    cliModelRLite: "AI解釈のみ、手頃・高速（₩330/リクエスト）",
    cliModelMLite: "AI解釈 + 万歳暦、手頃・高速（₩462/リクエスト）",
    cliSslTitle: "SSLエラー解決（macOS / Windows）",
    cliSslDesc: "CERTIFICATE_VERIFY_FAILED エラーの場合：",
    cliSslStep1: "実行（最も簡単、全OS対応）",
    installTitle: "インストール",
    basicCommands: "基本コマンド",
    interactiveMode: "対話モード（ollama runスタイル）",
    quickstartTitle: "クイックスタート — HTTP API",
    step1Analyze: "1. 四柱分析（前払いポイント自動差引）",
    step2Followup: "2. 追加質問（セッション維持）",
    apiRefTitle: "APIリファレンス",
    paramName: "パラメータ",
    paramType: "型",
    paramRequired: "必須",
    paramDesc: "説明",
    responseTitle: "レスポンス形式（JSON + Markdown）",
    responseDesc: "すべてのレスポンスはJSON形式です。AI解釈テキストはMarkdown記法です。",
    responseRTitle: "R / R-lite レスポンス（解釈のみ）",
    responseMTitle: "M / M-lite レスポンス（四柱要約 + 解釈）",
    responseLiteTitle: "Liteモデルレスポンス例",
    formatSpec: "形式仕様",
    errorCodesTitle: "エラーコード",
    errorExample: "エラーレスポンス例",
    thHTTP: "HTTP",
    thCode: "コード",
    thDescription: "説明",
    totalRequests: "総リクエスト",
    successRequests: "成功",
    totalCost: "総コスト",
    avgResponse: "平均レスポンス",
    byModel: "モデル別使用量",
    noUsage: "使用履歴がありません。",
    dailyTrend: "日別推移",
    currentPricing: "現在の単価",
    loginRequired: "開発者ポータルを利用するにはログインが必要です。",
    b2bGuideTitle: "B2B統合ガイド",
    b2bGuideDesc: "MobidicSaju APIを活用した四柱分析サービス構築ガイド。",
    b2bArch: "アーキテクチャ推奨事項",
    b2bArchDesc: "APIはバックエンドサーバーからのみ呼び出してください。フロントエンドでの直接呼び出しはキー漏洩の原因になります。",
    b2bErrorTitle: "エラーハンドリングのベストプラクティス",
    b2bRateTitle: "レート制限と最適化",
    b2bWebhookTitle: "結果キャッシュ戦略",
    b2bBestPractices: "プロダクションベストプラクティス",
    b2bTip1: "APIキーは必ずサーバー側でのみ使用 — フロントエンドへの露出禁止",
    b2bTip2: "ユーザーごとのリクエストレート制限を実装",
    b2bTip3: "結果キャッシュで重複APIコールを防止",
    b2bTip4: "timeout設定（推奨30秒）— AI分析に時間がかかる場合あり",
    b2bTip5: "残高不足(402)エラー対応 — 自動アラートシステム構築",
    b2bTip6: "session_tokenでフォローアップ質問機能を活用 — UX向上",
  },
  ru: {
    homeTitle: "СажуПальджаAI - Бесплатный AI Гороскоп Таро Совместимость | 2026",
    homeDesc: "AI-анализ четырёх столпов, таро и совместимости",
    heroTitle: "Сажу Пальджа AI",
    heroSubtitle: "AI-анализ: Сажу · Таро · Судьба",
    viewFortune: "Узнать судьбу",
    manseryeok: "Мансерёк",
    aiSaju: "AI Сажу",
    gunghap: "Совместимость",
    tarot: "Таро",
    asciiTarot: "ASCII Таро",
    fortuneServices: "Услуги гороскопа",
    aiSajuAnalysis: "AI Анализ Сажу",
    aiSajuDesc: "Традиция встречает AI",
    manseryeokTitle: "Мансерёк",
    manseryeokDesc: "Профессиональный анализ четырёх столпов",
    manseryeokAITitle: "Мансерёк AI",
    manseryeokAIDesc: "AI-интерпретация мансерёк",
    aiTarotReading: "AI Таро расклад",
    aiTarotDesc: "AI интерпретирует таро",
    aiGunghapTitle: "AI Совместимость",
    aiGunghapDesc: "Совместимость двух людей",
    featuredServices: "Рекомендуемые сервисы",
    psychtestTitle: "Психотест",
    psychtestDesc: "MBTI и анализ типа личности",
    communityTitle: "Сообщество",
    galleryTitle: "Галерея",
    galleryDesc: "Свободное общение",
    toolsTitle: "Инструменты",
    boardTitle: "Форум Сажу",
    boardDesc: "Обсуждения гороскопов",
    encyclopediaTitle: "Обучение",
    encyclopediaDesc: "Термины и концепции Сажу",
    devPortalTitle: "Dev Портал",
    devPortalDesc: "MobidicSaju API и CLI инструменты",
    whyUs: "Почему СажуПальджаAI?",
    featAI: "AI Анализ",
    featAIDesc: "Точность с новейшим AI",
    featFast: "Быстрый результат",
    featFastDesc: "Мгновенно после ввода",
    featSafe: "Защита данных",
    featSafeDesc: "Безопасное управление данными",
    ctaTitle: "Узнайте свой гороскоп на сегодня",
    ctaSub: "Любовь · Богатство · Карьера · Здоровье одним взглядом",
    ctaSaju: "AI Анализ Сажу",
    ctaTarot: "Таро расклад",
    // SajuFarm
    sajuFarmTitle: "Сажу прескрипция",
    sajuFarmDesc: "Растения · Пища · Сезон · Фэн-шуй · Летописи",
    annalsTitle: "Летописи Чосон",
    annalsDesc: "531 740 записей + География RAG",
    devHeroTitle: "Платформа MobidicSaju API",
    devHeroSub: "Сажу (четыре столпа) AI API. Интегрируйте анализ Саджу и AI интерпретацию в ваш сервис.",
    devApproved: "Разработчик одобрен",
    tabOverview: "Начало",
    tabDocs: "Документация",
    tabKeys: "API Ключи",
    tabUsage: "Статистика",
    securityTitle: "Безопасность API-ключа",
    securityNoSource: "НИКОГДА не включайте ключи в исходный код, Git или фронтенд.",
    securityRevoke: "При утечке ключа немедленно деактивируйте его и создайте новый.",
    securityEnvVar: "Используйте переменные окружения (MOBIDIC_API_KEY) или менеджер секретов.",
    securityBackend: "Вызывайте API только с бэкенд-сервера.",
    prepaidTitle: "Предоплатная система баллов",
    prepaidDesc: "API использует модель предоплатных баллов.",
    prepaidFlow: "1. Пополнение → 2. Вызов API → 3. Автосписание",
    prepaidWarn: "При недостатке баланса запрос отклоняется с кодом 402.",
    chargeLink: "Пополнить баланс",
    modelsTitle: "Модели",
    proLabel: "Pro",
    liteLabel: "Lite",
    liteSave: "На 34% дешевле",
    perRequest: "/ запрос",
    engineLabel: "Уровень",
    priceCompare: "Сравнение цен",
    thModel: "Модель",
    thEngine: "Уровень",
    thFormat: "Формат",
    thPrice: "Цена",
    thFeatures: "Функции",
    manseryeokPlusInterp: "Сводка Саджу + Интерпретация",
    interpOnly: "Только интерпретация",
    apiFlow: "Поток API",
    flowCharge: "Пополнение",
    flowCall: "Вызов API",
    flowBalance: "Проверка баланса",
    flowCalc: "Расчёт Мансерёк",
    flowAI: "AI Интерпретация",
    flowResponse: "JSON Ответ + Списание",
    flowRNote: "R / R-lite: только AI интерпретация",
    flowMNote: "M / M-lite: сводка Саджу + баланс У-син + AI интерпретация",
    flowProNote: "Pro: MobidicAI Pro (высокое качество) | Lite: MobidicAI Lite (быстро и доступно)",
    flowSessionNote: "Каждый запрос возвращает токен сессии для дополнительных вопросов.",
    flowBalanceNote: "При недостатке баланса запросы отклоняются (HTTP 402).",
    devApplyTitle: "Заявка на аккаунт разработчика",
    devApplyRejected: "Предыдущая заявка отклонена. Вы можете подать новую.",
    companyName: "Компания / Сервис",
    website: "Веб-сайт",
    purpose: "Цель использования",
    purposePlaceholder: "Опишите, как планируете использовать API.",
    applying: "Отправка...",
    applyBtn: "Подать заявку",
    pendingTitle: "Статус заявки",
    pendingDesc: "Заявка на рассмотрении. API-ключ будет доступен после одобрения администратором.",
    reviewing: "На рассмотрении",
    keyCreated: "API ключ создан",
    keyOnce: "Ключ показывается только один раз. Сохраните его в безопасном месте.",
    newKeyTitle: "Создать API ключ",
    keyNamePlaceholder: "Имя ключа (напр., Production, Test)",
    createBtn: "Создать",
    maxKeys: "Максимум 5 активных ключей.",
    keyListTitle: "Список API ключей",
    noKeys: "Нет созданных ключей.",
    active: "Активен",
    inactive: "Неактивен",
    deactivate: "Деактивировать",
    created: "Создан",
    lastUsed: "Последнее использование",
    authTitle: "Аутентификация и безопасность",
    authDesc: "Все запросы требуют заголовок X-API-Key.",
    cliTitle: "CLI инструмент (терминал)",
    cliDesc: "Ollama-подобный CLI для анализа Сажу прямо из терминала.",
    cliReq: "Работает сразу с Python 3.6+ — дополнительные библиотеки не нужны.",
    cliPlatform: "✅ macOS, Linux, Windows | CLI только на английском.",
    cliModelTip: "Руководство по выбору модели",
    cliModelDesc: "Доступно 4 модели на выбор:",
    cliModelR: "Только AI-интерпретация (₩500/запрос)",
    cliModelM: "AI-интерпретация + данные Мансерёк (₩700/запрос)",
    cliModelRLite: "Только AI-интерпретация, бюджетно и быстро (₩330/запрос)",
    cliModelMLite: "AI-интерпретация + Мансерёк, бюджетно и быстро (₩462/запрос)",
    cliSslTitle: "Исправление ошибки SSL (macOS / Windows)",
    cliSslDesc: "Если появляется CERTIFICATE_VERIFY_FAILED:",
    cliSslStep1: "Запустите (проще всего, все ОС)",
    installTitle: "Установка",
    basicCommands: "Основные команды",
    interactiveMode: "Интерактивный режим (стиль ollama run)",
    quickstartTitle: "Быстрый старт — HTTP API",
    step1Analyze: "1. Анализ Сажу (автосписание баллов)",
    step2Followup: "2. Дополнительный вопрос (на основе сессии)",
    apiRefTitle: "Справочник API",
    paramName: "Параметр",
    paramType: "Тип",
    paramRequired: "Обязат.",
    paramDesc: "Описание",
    responseTitle: "Формат ответа (JSON + Markdown)",
    responseDesc: "Все ответы в формате JSON. AI текст в Markdown.",
    responseRTitle: "R / R-lite ответ (только интерпретация)",
    responseMTitle: "M / M-lite ответ (сводка Саджу + интерпретация)",
    responseLiteTitle: "Пример ответа Lite модели",
    formatSpec: "Спецификация формата",
    errorCodesTitle: "Коды ошибок",
    errorExample: "Пример ошибки",
    thHTTP: "HTTP",
    thCode: "Код",
    thDescription: "Описание",
    totalRequests: "Всего запросов",
    successRequests: "Успешных",
    totalCost: "Общая стоимость",
    avgResponse: "Среднее время",
    byModel: "По моделям",
    noUsage: "Нет данных.",
    dailyTrend: "Дневная динамика",
    currentPricing: "Текущие цены",
    loginRequired: "Для доступа к порталу необходимо войти.",
    b2bGuideTitle: "Руководство B2B интеграции",
    b2bGuideDesc: "Руководство по созданию сервисов анализа Сажу с MobidicSaju API.",
    b2bArch: "Рекомендации по архитектуре",
    b2bArchDesc: "Вызывайте API только с бэкенда. Фронтенд вызовы раскрывают ключ.",
    b2bErrorTitle: "Лучшие практики обработки ошибок",
    b2bRateTitle: "Лимиты и оптимизация",
    b2bWebhookTitle: "Стратегия кэширования результатов",
    b2bBestPractices: "Лучшие практики для продакшна",
    b2bTip1: "API-ключ только на сервере — никогда не открывайте во фронтенде",
    b2bTip2: "Реализуйте ограничение запросов на пользователя",
    b2bTip3: "Кэшируйте результаты для предотвращения дублирования запросов",
    b2bTip4: "Установите timeout (30 секунд) — AI-анализ может занять время",
    b2bTip5: "Обрабатывайте ошибку недостаточного баланса (402) — настройте авто-уведомления",
    b2bTip6: "Используйте session_token для дополнительных вопросов — улучшение UX",
  },
  de: {
    homeTitle: "SajuPaljaAI - Kostenloses AI Horoskop Tarot Kompatibilität | 2026",
    homeDesc: "AI-gestützte Saju-, Tarot- und Kompatibilitätsanalyse",
    heroTitle: "Saju Palja AI",
    heroSubtitle: "AI-Analyse: Saju · Tarot · Horoskop",
    viewFortune: "Horoskop ansehen",
    manseryeok: "Manseryeok",
    aiSaju: "AI Saju",
    gunghap: "Kompatibilität",
    tarot: "Tarot",
    asciiTarot: "ASCII-Tarot",
    fortuneServices: "Horoskop-Dienste",
    aiSajuAnalysis: "AI Saju-Analyse",
    aiSajuDesc: "Tradition trifft auf AI",
    manseryeokTitle: "Manseryeok",
    manseryeokDesc: "Professionelle Vier-Säulen-Analyse",
    manseryeokAITitle: "Manseryeok AI",
    manseryeokAIDesc: "AI interpretiert Manseryeok",
    aiTarotReading: "AI Tarot-Lesung",
    aiTarotDesc: "AI-interpretierte Tarotkarten",
    aiGunghapTitle: "AI Kompatibilität",
    aiGunghapDesc: "Kompatibilität zweier Personen",
    featuredServices: "Empfohlene Dienste",
    psychtestTitle: "Psychotest",
    psychtestDesc: "MBTI & Persönlichkeitsanalyse",
    communityTitle: "Community",
    galleryTitle: "Galerie",
    galleryDesc: "Freie Community-Diskussionen",
    toolsTitle: "Tools",
    boardTitle: "Saju-Forum",
    boardDesc: "Horoskop-Diskussionen",
    encyclopediaTitle: "Lernmaterial",
    encyclopediaDesc: "Saju-Begriffe & Konzepte",
    devPortalTitle: "Entwicklerportal",
    devPortalDesc: "MobidicSaju API & CLI-Tools",
    whyUs: "Warum SajuPaljaAI?",
    featAI: "AI-Analyse",
    featAIDesc: "Genau mit neuester AI",
    featFast: "Schnelle Ergebnisse",
    featFastDesc: "Sofort nach Eingabe",
    featSafe: "Datenschutz",
    featSafeDesc: "Sichere Datenverwaltung",
    ctaTitle: "Prüfen Sie Ihr heutiges Horoskop",
    ctaSub: "Liebe · Reichtum · Karriere · Gesundheit auf einen Blick",
    ctaSaju: "AI Saju-Analyse",
    ctaTarot: "Tarot-Lesung",
    // SajuFarm
    sajuFarmTitle: "Saju-Lebensrezept",
    sajuFarmDesc: "Pflanzen · Heilkost · Jahreszeit · Feng Shui · Annalen",
    annalsTitle: "Joseon-Annalen",
    annalsDesc: "531.740 Einträge + Geografie RAG-Suche",
    devHeroTitle: "MobidicSaju API-Plattform",
    devHeroSub: "Saju (Vier Säulen) AI API. Integrieren Sie Saju-Analyse und AI-Interpretation in Ihren Service.",
    devApproved: "Entwickler genehmigt",
    tabOverview: "Erste Schritte",
    tabDocs: "API-Dokumentation",
    tabKeys: "API-Schlüssel",
    tabUsage: "Nutzung",
    securityTitle: "API-Schlüssel Sicherheitshinweis",
    securityNoSource: "NIEMALS API-Schlüssel in Quellcode, Git oder Frontend einbinden.",
    securityRevoke: "Bei Schlüsselverlust sofort deaktivieren und neuen erstellen.",
    securityEnvVar: "Verwenden Sie Umgebungsvariablen (MOBIDIC_API_KEY) oder einen Secrets Manager.",
    securityBackend: "API nur vom Backend-Server aufrufen.",
    prepaidTitle: "Prepaid-Punktesystem",
    prepaidDesc: "MobidicSaju API nutzt ein Prepaid-Punkteabzugsmodell.",
    prepaidFlow: "1. Punkte aufladen → 2. API-Aufruf → 3. Automatischer Abzug",
    prepaidWarn: "Bei unzureichendem Guthaben wird die Anfrage mit 402 abgelehnt.",
    chargeLink: "Punkte aufladen",
    modelsTitle: "Modelle",
    proLabel: "Pro",
    liteLabel: "Lite",
    liteSave: "34% günstiger",
    perRequest: "/ Anfrage",
    engineLabel: "Stufe",
    priceCompare: "Preisvergleich",
    thModel: "Modell",
    thEngine: "Stufe",
    thFormat: "Ausgabeformat",
    thPrice: "Preis",
    thFeatures: "Funktionen",
    manseryeokPlusInterp: "Saju-Zusammenfassung + Interpretation",
    interpOnly: "Nur Interpretation",
    apiFlow: "API-Ablauf",
    flowCharge: "Punkte aufladen",
    flowCall: "API-Aufruf",
    flowBalance: "Guthaben prüfen",
    flowCalc: "Manseryeok Berechnung",
    flowAI: "AI Interpretation",
    flowResponse: "JSON Antwort + Abzug",
    flowRNote: "R / R-lite: Nur AI-Interpretation",
    flowMNote: "M / M-lite: Saju-Zusammenfassung + Wuxing-Balance + AI-Interpretation",
    flowProNote: "Pro: MobidicAI Pro (hohe Qualität) | Lite: MobidicAI Lite (schnell & günstig)",
    flowSessionNote: "Jede Anfrage gibt ein Session-Token für Folgefragen zurück.",
    flowBalanceNote: "Bei unzureichendem Guthaben werden Anfragen abgelehnt (HTTP 402).",
    devApplyTitle: "Entwicklerkonto beantragen",
    devApplyRejected: "Ihr vorheriger Antrag wurde abgelehnt. Sie können erneut einreichen.",
    companyName: "Firma / Servicename",
    website: "Website",
    purpose: "Verwendungszweck",
    purposePlaceholder: "Beschreiben Sie, wie Sie die API nutzen möchten.",
    applying: "Wird gesendet...",
    applyBtn: "Entwicklerkonto beantragen",
    pendingTitle: "Antragsstatus",
    pendingDesc: "Ihr Antrag wird geprüft. API-Schlüssel nach Genehmigung verfügbar.",
    reviewing: "In Prüfung",
    keyCreated: "API-Schlüssel erstellt",
    keyOnce: "Dieser Schlüssel wird nur einmal angezeigt. Sicher aufbewahren.",
    newKeyTitle: "Neuen API-Schlüssel erstellen",
    keyNamePlaceholder: "Schlüsselname (z.B. Production, Test)",
    createBtn: "Erstellen",
    maxKeys: "Maximal 5 aktive Schlüssel.",
    keyListTitle: "API-Schlüssel Liste",
    noKeys: "Keine API-Schlüssel vorhanden.",
    active: "Aktiv",
    inactive: "Inaktiv",
    deactivate: "Deaktivieren",
    created: "Erstellt",
    lastUsed: "Zuletzt benutzt",
    authTitle: "Authentifizierung & Sicherheit",
    authDesc: "Alle Anfragen benötigen den X-API-Key Header.",
    cliTitle: "CLI-Tool (Terminal)",
    cliDesc: "Ollama-ähnliches CLI-Tool für Saju-Analyse direkt im Terminal.",
    cliReq: "Funktioniert sofort mit Python 3.6+ — keine zusätzlichen Bibliotheken nötig.",
    cliPlatform: "✅ macOS, Linux, Windows unterstützt | CLI nur auf Englisch.",
    cliModelTip: "Modellauswahl-Leitfaden",
    cliModelDesc: "Wählen Sie aus 4 verfügbaren Modellen:",
    cliModelR: "Nur AI-Deutung (₩500/Anfrage)",
    cliModelM: "AI-Deutung + Manseryeok-Daten (₩700/Anfrage)",
    cliModelRLite: "Nur AI-Deutung, günstig & schnell (₩330/Anfrage)",
    cliModelMLite: "AI-Deutung + Manseryeok, günstig & schnell (₩462/Anfrage)",
    cliSslTitle: "SSL-Fehler beheben (macOS / Windows)",
    cliSslDesc: "Bei CERTIFICATE_VERIFY_FAILED Fehler:",
    cliSslStep1: "Ausführen (einfachste Methode, alle OS)",
    installTitle: "Installation",
    basicCommands: "Grundlegende Befehle",
    interactiveMode: "Interaktiver Modus (ollama run Stil)",
    quickstartTitle: "Schnellstart — HTTP API",
    step1Analyze: "1. Saju-Analyse (automatischer Punkteabzug)",
    step2Followup: "2. Folgefrage (sitzungsbasiert)",
    apiRefTitle: "API-Referenz",
    paramName: "Parameter",
    paramType: "Typ",
    paramRequired: "Pflicht",
    paramDesc: "Beschreibung",
    responseTitle: "Antwortformat (JSON + Markdown)",
    responseDesc: "Alle Antworten sind im JSON-Format. AI-Text verwendet Markdown.",
    responseRTitle: "R / R-lite Antwort (nur Interpretation)",
    responseMTitle: "M / M-lite Antwort (Saju-Zusammenfassung + Interpretation)",
    responseLiteTitle: "Lite-Modell Antwortbeispiel",
    formatSpec: "Formatspezifikation",
    errorCodesTitle: "Fehlercodes",
    errorExample: "Fehlerantwort Beispiel",
    thHTTP: "HTTP",
    thCode: "Code",
    thDescription: "Beschreibung",
    totalRequests: "Gesamtanfragen",
    successRequests: "Erfolgreich",
    totalCost: "Gesamtkosten",
    avgResponse: "Durchschn. Antwort",
    byModel: "Nach Modell",
    noUsage: "Keine Daten.",
    dailyTrend: "Tagesverlauf",
    currentPricing: "Aktuelle Preise",
    loginRequired: "Bitte anmelden, um auf das Entwicklerportal zuzugreifen.",
    b2bGuideTitle: "B2B-Integrationsleitfaden",
    b2bGuideDesc: "Leitfaden zum Aufbau von Saju-Analysediensten mit der MobidicSaju API.",
    b2bArch: "Architekturempfehlungen",
    b2bArchDesc: "API nur vom Backend aufrufen. Frontend-Aufrufe legen den Schlüssel offen.",
    b2bErrorTitle: "Best Practices Fehlerbehandlung",
    b2bRateTitle: "Ratenlimits & Optimierung",
    b2bWebhookTitle: "Ergebnis-Caching-Strategie",
    b2bBestPractices: "Best Practices für Produktion",
    b2bTip1: "API-Schlüssel nur serverseitig verwenden — niemals im Frontend offenlegen",
    b2bTip2: "Rate-Limiting pro Benutzer implementieren",
    b2bTip3: "Ergebnisse cachen, um doppelte API-Aufrufe zu vermeiden",
    b2bTip4: "Timeout einstellen (empfohlen 30s) — AI-Analyse kann dauern",
    b2bTip5: "Unzureichendes Guthaben (402) behandeln — Auto-Benachrichtigungen einrichten",
    b2bTip6: "session_token für Folgefragen nutzen — UX verbessern",
  },
};

export default pageT;
